import moment from "moment";

export function formatDate(timestamp: number): string | null {

  const formattedTimestamp = timestamp % 1 === 0 ? timestamp : timestamp * 1000;
  const date = new Date(formattedTimestamp);

  if (isNaN(date.getTime())) {
    return null;
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${month}-${day}-${year}`;
}

export function formatDateDDMMMYYYY(timestamp: number): string | null {

  const formattedTimestamp = timestamp % 1 === 0 ? timestamp : timestamp * 1000;
  const date = new Date(formattedTimestamp);

  if (isNaN(date.getTime())) {
    return null;
  }

  const day = date.getDate().toString().padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
}

export const formatDateToYYYYMMDD = (date: Date | null): string => {
  if (!date) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export function formatDateWithTime(dateString: string | number): string | null {
  const timestamp = typeof dateString === 'number'
    ? dateString
    : parseFloat(dateString);

  const formattedTimestamp = timestamp > 1e10 ? timestamp : timestamp * 1000;
  const date = new Date(formattedTimestamp);

  return isNaN(date.getTime())
    ? null
    : moment.utc(date).format("MMM-DD-YYYY, hh:mm A [UTC]");
}

export function parseJson(input: any) {
  try {
    return JSON.parse(input);
  } catch (e) {
    const fixedInput = input.replace(/'/g, '"');
    try {
      return JSON.parse(fixedInput);
    } catch (e) {
      throw new Error('Invalid JSON format');
    }
  }
}

export function formatDateWithTimeDDMMMYYYY(dateString: string | number): string | null {
  const timestamp = typeof dateString === 'number'
    ? dateString
    : parseFloat(dateString);

  const formattedTimestamp = timestamp > 1e10 ? timestamp : timestamp * 1000;
  const date = new Date(formattedTimestamp);

  return isNaN(date.getTime())
    ? null
    : moment.utc(date).format("DD-MMM-YYYY");
}